import useReveal from "../hooks/useReveal";
import { MapPin } from "lucide-react";
import { serviceAreas } from "../mock/mock";

export default function ServiceAreas() {
  const [ref, inView] = useReveal();

  return (
    <section className="py-20 bg-[#2A2521]">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div ref={ref} className={`text-center max-w-2xl mx-auto mb-12 reveal ${inView ? "in-view" : ""}`}>
          <p className="text-[#E7CFA6] tracking-[0.25em] uppercase text-xs mb-4">Areas We Serve</p>
          <h2 className="font-serif text-2xl md:text-4xl text-white">
            Proudly Serving Richmond Hill &amp; Beyond
          </h2>
        </div>
        <div className="flex flex-wrap justify-center gap-3">
          {serviceAreas.map((a) => (
            <span
              key={a}
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full border border-white/15 text-white/80 hover:border-[#A17E4A] hover:text-white transition-colors"
            >
              <MapPin className="w-4 h-4 text-[#A17E4A]" />
              {a}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
